import React from 'react';
import {
  getPostCategoryInThai,
  PostSubcategory,
} from '../../../common/helpers/domain/postCategories';
import { postCardImageConfig } from '../../../common/helpers/sharpie/sharpie';
import { useSharpie } from '../../../common/helpers/sharpie/useSharpie';
import commonResource from '../../../locales/th/common.json';
import { PostProject } from '../../../queries/contentPage/postDetail';
import { Tag } from '../../../queries/fragments/project';
import LazyImage from '../../lazyImage/LazyImage';
import { PlayIcon } from '../../playIcon/PlayIcon';
import { PostCardBody, PostCardImage, PostCardWrapper } from './PostCard.style';

export interface PostInfo {
  id: number;
  imageUrl: string;
  isVideo: boolean;
  authorName: string;
  category: PostSubcategory;
  title: string;
  link: string;
  videoType: string;
  tags?: Tag[];
  project?: PostProject;
}

export interface PostCardProps {
  post: PostInfo;
  onClickPostCard?: (post: PostInfo) => void;
  onClickVideoCard?: (post: PostInfo) => void;
}

/**
 * PostCard UI component
 *
 * @param post
 * @param onClickPostCard
 * @constructor
 */
export const PostCard: React.FC<PostCardProps> = ({
  post,
  onClickPostCard,
}) => {
  const sharpieImageUrl = useSharpie(
    post.imageUrl,
    postCardImageConfig,
    'crop',
  );

  return (
    <PostCardWrapper
      href={post.link}
      title={post.title}
      data-test="post-card"
      onClick={() => onClickPostCard(post)}
    >
      <PostCardImage>
        {post.isVideo && (
          <span className="play-icon-wrapper">
            <PlayIcon />
          </span>
        )}
        <LazyImage src={sharpieImageUrl} alt={post.title} lazyLoad />
      </PostCardImage>
      <PostCardBody>
        <div className="category-tag" data-test="post-card-category">
          {getPostCategoryInThai(post.category)}
        </div>
        <h3 className="title" title={post.title} data-test="post-card-title">
          {post.title}
        </h3>
        <div className="footer" data-test="post-card-author">
          {commonResource.by}{' '}
          <span className="author-name">{post.authorName}</span>
        </div>
      </PostCardBody>
    </PostCardWrapper>
  );
};
